/** @jsxImportSource @emotion/react */
import css from '@emotion/css/macro'
import colors from '@sportninja/common/constants/appColors'

import { useObjectUrl } from '../../hooks/useObjectUrl'

interface ImportCSVFailedRowsLinkProps {
  /** The failed rows exactly as the import returned them (`file.rows`). */
  csv: string
  /** The file name the import suggested (`file.name`). */
  fileName: string
}

/**
 * "Download CSV with failed rows", shown by every import screen after row
 * errors. The file is served from a blob: URL so its bytes reach the user
 * unchanged, '#', '%' and line breaks included.
 */
const ImportCSVFailedRowsLink = ({
  csv,
  fileName,
}: ImportCSVFailedRowsLinkProps) => {
  'use memo'
  const href = useObjectUrl(csv, 'text/csv;charset=utf-8')

  return (
    <div css={wrapperStyles}>
      <a css={linkStyles} href={href} download={fileName}>
        Download CSV with failed rows
      </a>
    </div>
  )
}

export default ImportCSVFailedRowsLink

// ---- styles ----

const wrapperStyles = css`
  display: flex;
  margin-bottom: 16px;
`

const linkStyles = css`
  border-radius: 4px;
  border: 2px solid ${colors.DEFAULT_FLAIR};
  padding: 8px 16px;
`
